module.exports = __webpack_public_path__ + "files/05e19e0579d655334c088917d3aa2c98.png";